const ecommerceServicesData = [
  {
    title: "E-Commerce Web Design & Development",
    description:
      "Craft visually appealing, conversion-focused storefronts with modern UX/UI.",
    bullets: [
      "Custom Themes",
      "Mobile-First",
      "SEO-Ready",
      "A11y Focus",
    ],
    minHeight: 400,
  },
  {
    title: "Payment & Checkout",
    description:
      "Secure payments with optimized checkout to reduce friction and boost conversions.",
    bullets: [
      "Stripe/Razorpay/PayPal",
      "One-Page Checkout",
      "3-D Secure",
      "Apple/Google Pay",
    ],
    minHeight: 400,
  },
  {
    title: "Catalog & Order Management",
    description:
      "Advanced product catalogs, variants, pricing rules, and streamlined order flows.",
    bullets: [
      "Variants/Attributes",
      "Coupons & Bundles",
      "Returns/Refunds",
      "Vendor Portal",
    ],
    minHeight: 400,
  },
  {
    title: "Performance & SEO",
    description:
      "Core Web Vitals, structured data, and caching/CDN for lightning-fast stores.",
    bullets: [
      "CWV Targets",
      "Image/CDN",
      "Schema/OG",
      "Sitemaps",
    ],
    minHeight: 400,
  },
  {
    title: "Headless Commerce",
    description:
      "Composable, API-first storefronts with modern frameworks and commerce backends.",
    bullets: [
      "Next.js/Nuxt",
      "Shopify/Magento APIs",
      "Contentful/Sanity",
      "Edge Rendering",
    ],
    minHeight: 400,
  },
  {
    title: "Subscriptions & Loyalty",
    description:
      "Recurring billing, memberships, and rewards to grow LTV.",
    bullets: [
      "Subscriptions",
      "Wallet/Points",
      "Referral",
      "Churn Reduction",
    ],
    minHeight: 400,
  },
];

export const Cards = [
  { icon: "fa-solid fa-user-gear", title: "Personalized Shopping Experiences", text: "Deliver unique, tailored experiences for every customer based on browsing behavior, purchase history, and preferences." },
  { icon: "fa-solid fa-vr-cardboard", title: "AR & AI for Virtual Try-Ons", text: "Use AI + AR to let users virtually try on clothes, glasses, or makeup — enhancing user experience and reducing returns." },
  { icon: "fa-solid fa-shirt", title: "Smart Size & Fit Prediction (Fashion eCommerce)", text: "Use AI to recommend accurate clothing sizes based on customer inputs and past purchase/return data, reducing returns." },
  { icon: "fa-solid fa-chart-line", title: "Demand Forecasting & Inventory Optimization", text: "Predict demand, automate restocking, and reduce waste — all through AI-powered inventory systems." },
  { icon: "fa-solid fa-pen-to-square", title: "AI-Generated Product Descriptions", text: "Automatically write SEO-optimized, personalized product descriptions at scale using generative AI tools." },
  { icon: "fa-solid fa-robot", title: "AI Chatbots for Pre-Sales & Support", text: "Handle product queries, order tracking, FAQs, and returns — available 24/7 with natural language understanding." },
  { icon: "fa-solid fa-magnifying-glass-chart", title: "Predictive Analytics for Marketing", text: "Understand what your customers want before they do. Forecast trends, segment audiences, and launch data-driven campaigns." },
  { icon: "fa-solid fa-shield-halved", title: "Fraud Detection & Prevention", text: "Secure transactions with AI models that detect anomalies, reduce chargebacks, and protect your store from fraudulent activity." },
];

export const DEFAULT_IMAGES = [
  "/assets/img/Athletenutirtion.png",
  "/assets/img/projects/dakzy/Dakzy cover.png",
  "/assets/img/servicesdetail.jpg",
];

export const LEFT_ITEMS = [
  { icon: "fa-solid fa-grip", title: "User‑Friendly Interface" },
  { icon: "fa-solid fa-shield", title: "Secure Payment Processing" },
  { icon: "fa-solid fa-cart-shopping", title: "Shopping Cart and Checkout" },
];

export const RIGHT_ITEMS = [
  { icon: "fa-solid fa-user-group", title: "Customer Management" },
  { icon: "fa-solid fa-rotate-right", title: "Regular Updates" },
  { icon: "fa-solid fa-chart-line", title: "Analytics and Reporting" },
];
export default ecommerceServicesData;
